<template>
  <div class="login-box">
    <div class="login-logo-box">
      <!-- <img :src="logoimg" alt style="width: 1.9306rem; height: 0.9722rem" /> -->
    </div>
    <div class="login-title-box">
      <div class="welcome">欢迎使用</div>
      <div class="welcome-title">充电桩商户管理平台</div>
    </div>
    <div class="input-box">
      <div class="l-input-box">
        <div class="input-title"></div>
        <div class="input-item">
          <el-input
              maxlength="20"
              v-model="form.phone"
              placeholder="请输入用户名"
              size="normal"
              clearable
          >
            <i
                class="el-icon-user el-input__icon"
                slot="suffix"
            />
          </el-input>
        </div>
        <div class="input-item">
          <el-input
              maxlength="18"
              v-model="form.code"
              placeholder="密码"
              size="normal"
              clearable
              type="password"
          >
            <i class="el-icon-unlock el-input__icon"
               slot="suffix"/>
          </el-input>
        </div>
        <div class="input-item">
          <div>
            <mu-button class="login-btn" @click="login">登录</mu-button>
          </div>
        </div>
      </div>
      <div class="check">
        <div>
          <el-radio-group v-model="form.radio">
            <el-checkbox v-model="form.radio">
              <span class="text">我已阅读并同意 </span>

              <b class="agree" @click.stop="handPolicy">用户协议</b>
            </el-checkbox>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import "vant/lib/toast/style/index";
import store from "store";
import {login} from "@/api/newApi";
import {getInfoByKey, queryNewsByNewsConfigKey} from "@/api/newApi";

export default {
  data() {
    return {
      logoimg: "",
      // activeTitle: "请选择登录主体",
      form: {
        phone: "",
        code: "",
        platForm: "4",
      },
      // defaultValueData: [{
      //   value: "四轮车",
      //   label: "4"
      // },],
      option: "请选择",
      isVisible: false,
      content: "",
      // selectOptions: [
      //   [{
      //     value: "四轮车",
      //     label: "4"
      //   },
      //   {
      //     value: "二轮车",
      //     label: "2"
      //   }]
      // ],
      // back: {
      //   background: "url(" + require("../../assets/image/login.jpg") + ")",
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "cover"
      // }
    };
  },
  created() {
    this.form.phone = window.localStorage.getItem("phone");
    this.form.code = window.localStorage.getItem("code");
    this.getConfigData("dls_login_logo");
    this.queryNewsByNewsConfigKey();
  },
  methods: {
    handPolicy() {
      console.log(11111);
      this.$router.push({path: "/admin/policy"});
    },

    getConfigData(value) {
      let param = {
        configKey: value,
      };
      getInfoByKey(param).then((res) => {
        if (res.data) {
          this.logoimg = res.data;
        }
      });
    },

    queryNewsByNewsConfigKey() {
      let param = {
        configKey: 100,
        type: 1,
      };
      queryNewsByNewsConfigKey(param).then((res) => {
        if (res.data) {
          this.content = res.data;
          console.log(this.content);
        }
      });
    },

    login() {
      if (!this.form.phone) {
        Toast("用户名不能为空!");
        return;
      }
      //  if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.phone)) {
      //   Toast("手机号码有误，请重填");
      //   return false;
      // }
      if (!this.form.code) {
        Toast("密码不能为空");
        return;
      }
      if (!this.form.radio) {
        Toast("请同意用户协议");
        return;
      }
      login({
        userName: this.form.phone,
        password: this.form.code,
        platForm: this.form.platForm,
      }).then((res) => {
        console.log(res);
        if (res.message.code == 0) {
          Toast("登录成功");
          let token = res.data.token;
          this.$store.dispatch("setAdminUser", res.data.userInfo);
          window.localStorage.setItem("token", token);
          // window.localStorage.setItem("phone", this.form.phone);
          // window.localStorage.setItem("code", this.form.code);
          window.localStorage.setItem("userId", res.data.userInfo.id);
          store.set("adminuser", {adminuser: res.data.userInfo});
          console.log(window.localStorage.getItem("token"));
          if (window.localStorage.getItem("token")) {
            this.$router.push({
              path: "/admin/equipment",
            });
          }
        } else {
          Toast(res.message.message);

          // this.form.phone='';
          // this.form.code='';
        }
      });
    },
    openSwitch() {
      this.isVisible = true;
    },
    closeSwitch() {
      this.isVisible = false;
    },
    confirm(even) {
      this.isVisible = false;
      this.form.platForm = even[0].label;
      this.activeTitle = even[0].value;
    },
    forgetPassworld() {
    },
  },
};
</script>

<style lang="scss" scoped>
.login-box {
  position: relative;
  background: linear-gradient(161deg, #F0F3FF 22%, #ECF7FD 55%, #F7F7F7 100%);
  width: 100%;
  height: 100vh;

  .login-title-box {
    position: absolute;
    top: 2.5rem;
    left: 0.8654rem;

    .welcome {
      font-size: 0.535rem;
      font-weight: bold;
    }
    .welcome-title{
      margin-top: 0.12rem;
      font-size: 0.635rem;
      font-weight: bold;
    }
  }

  .login-logo-box {
    background: url("~@/assets/image/newImg/login-bg_1.png") no-repeat;
    background-size: contain;
    background-position: 0 -1.1rem;
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .input-box {
    left: 24px;
    right: 24px;
    position: absolute;
    top: 5.084rem;
  }

  .l-input-box {
    padding: 20px 15px;

    .input-title {
      width: 1.8rem;
      height: 0.59rem;
      padding-bottom: 4px;
      font-size: 0.36rem;
      position: relative;
      font-weight: bold;
      text-align: left;

      &:after {
        content: '账户登录';
        position: absolute;
        left: 0;
        width: 100%;
      }

      &:before {
        content: '';
        position: absolute;
        height: 0.2rem;
        width: 50%;
        background: #FE8012;
        bottom: 0.1rem;
        left: -15%;
        right: 0;
        margin: 0 auto;
        border-radius: 0.5rem;
      }
    }

    .input-item {
      margin: 20px 0;
    }

    ::v-deep .el-input__inner {
      background-color: #fff;
      border-radius: 7px;
      color: #999999;
      border: 1px solid #f5f5f5;
      box-shadow: 0px 4px 9px 0px rgba(160, 191, 254, 0.39);
    }

    ::v-deep .el-checkbox__inner {
      background-color: #2463ce;
      border: 1px solid transparent;
      border-radius: 0 !important;
    }

    .fright {
      margin: 20px 0 30px 0;
    }
  }

  .login-btn {
    height: 1.3rem;
    background: #003acc;
    box-shadow: 0px 4px 10px 0px rgba(61, 100, 178, 0.61);
    border-radius: 0.8rem;
    margin-top: 15px;
    width: 100%;
    color: #fff;
  }

  .check {
    font-size: 12px;
    width: 100%;
    margin: 0.7rem auto;
    display: flex;
    justify-content: center;
    align-items: center;

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #2364c8 !important;
      border-color: #2364c8 !important;
    }

    .agree {
      color: #4A81FF;
      text-decoration: underline;
    }

    .text {
      color: #666666;
    }
  }
}
</style>
